<app-modal
  [title]="'profile.changePassword.title' | transloco"
  icon="bi-lock"
  [errorMessage]="errorMessage() || null"
  [isSubmitting]="isLoading()"
  [isDisabled]="!form.valid"
  [confirmLabel]="'profile.changePassword.confirmLabel' | transloco"
  [submittingLabel]="'profile.changePassword.savingLabel' | transloco"
  [cancelLabel]="'profile.changePassword.cancelLabel' | transloco"
  (confirm)="onSubmit()"
  (cancelled)="modal.close()"
>
  @if (successMessage()) {
    <div class="alert alert-success" role="alert">
      <i class="bi bi-check-circle-fill me-2"></i>
      {{ successMessage() }}
    </div>
  }

  @if (errorMessage()) {
    <div class="alert alert-danger" role="alert">
      <i class="bi bi-exclamation-triangle-fill me-2"></i>
      {{ errorMessage() }}
    </div>
  }

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <!-- Senha atual -->
    <div class="mb-3">
      <label for="oldPassword" class="form-label text-secondary-brand fw-semibold">
        {{ 'profile.changePassword.oldPasswordLabel' | transloco }}
      </label>

      <div class="input-group">
        <span class="input-group-text">
          <i class="bi bi-lock"></i>
        </span>

        <input
          id="oldPassword"
          [type]="showoldPassword() ? 'text' : 'password'"
          class="form-control"
          formControlName="oldPassword"
          [class.is-invalid]="isInvalid('oldPassword')"
          [placeholder]="'profile.changePassword.oldPasswordPlaceholder' | transloco"
          [autocomplete]="'current-password'"
          [attr.maxlength]="MAX_PASSWORD_LENGTH"
        />

        <button type="button" class="btn btn-outline-secondary" (click)="showoldPassword.set(!showoldPassword())">
          <i [class]="showoldPassword() ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
        </button>
      </div>

      @if (isInvalid('oldPassword')) {
        <div class="invalid-feedback d-block">
          <i class="bi bi-exclamation-circle me-1"></i>
          {{ 'profile.changePassword.oldPasswordRequired' | transloco }}
        </div>
      }

      <small class="text-secondary-brand float-end">
        {{ form.get('oldPassword')?.value?.length ?? 0 }}/{{ MAX_PASSWORD_LENGTH }}
      </small>
    </div>

    <!-- Nova senha -->
    <div class="mb-3">
      <label for="newPassword" class="form-label text-secondary-brand fw-semibold">
        {{ 'profile.changePassword.newPasswordLabel' | transloco }}
      </label>

      <div class="input-group">
        <span class="input-group-text">
          <i class="bi bi-lock-fill"></i>
        </span>

        <input
          id="newPassword"
          [type]="showNewPassword() ? 'text' : 'password'"
          class="form-control"
          formControlName="newPassword"
          [class.is-invalid]="isInvalid('newPassword')"
          [placeholder]="'profile.changePassword.newPasswordPlaceholder' | transloco"
          [autocomplete]="'new-password'"
          [attr.maxlength]="MAX_PASSWORD_LENGTH"
        />

        <button type="button" class="btn btn-outline-secondary" (click)="showNewPassword.set(!showNewPassword())">
          <i [class]="showNewPassword() ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
        </button>
      </div>

      @if (isInvalid('newPassword')) {
        <div class="invalid-feedback d-block">
          <i class="bi bi-exclamation-circle me-1"></i>
          {{ getNewPasswordError() }}
        </div>
      }

      <small class="text-secondary-brand float-end">
        {{ form.get('newPassword')?.value?.length ?? 0 }}/{{ MAX_PASSWORD_LENGTH }}
      </small>
    </div>

    <!-- Confirmar nova senha -->
    <div class="mb-1">
      <label for="confirmPassword" class="form-label text-secondary-brand fw-semibold">
        {{ 'profile.changePassword.confirmPasswordLabel' | transloco }}
      </label>

      <div class="input-group">
        <span class="input-group-text">
          <i class="bi bi-lock-fill"></i>
        </span>

        <input
          id="confirmPassword"
          [type]="showConfirmPassword() ? 'text' : 'password'"
          class="form-control"
          formControlName="confirmPassword"
          [class.is-invalid]="
            isInvalid('confirmPassword') || (form.hasError('passwordMismatch') && form.get('confirmPassword')?.touched)
          "
          [placeholder]="'profile.changePassword.confirmPasswordPlaceholder' | transloco"
          [autocomplete]="'new-password'"
          [attr.maxlength]="MAX_PASSWORD_LENGTH"
        />

        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="showConfirmPassword.set(!showConfirmPassword())"
        >
          <i [class]="showConfirmPassword() ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
        </button>
      </div>

      @if (isInvalid('confirmPassword')) {
        <div class="invalid-feedback d-block">
          <i class="bi bi-exclamation-circle me-1"></i>
          {{ 'profile.changePassword.confirmPasswordRequired' | transloco }}
        </div>
      } @else if (form.hasError('passwordMismatch') && form.get('confirmPassword')?.touched) {
        <div class="text-danger small mt-1">
          <i class="bi bi-exclamation-circle me-1"></i>
          {{ 'profile.changePassword.passwordMismatch' | transloco }}
        </div>
      }

      <small class="text-secondary-brand float-end">
        {{ form.get('confirmPassword')?.value?.length ?? 0 }}/{{ MAX_PASSWORD_LENGTH }}
      </small>
    </div>
  </form>
</app-modal>
